// =================================================================
// Config: Nomogram boundary coordinate data (PSD §4.2.6 / TODO T.39)
// Shared between engine (classification) and UI (visualization).
// =================================================================
export const HARTFORD_BOUNDARIES = {
    q24q36: [
        [6, 6.0],
        [8, 5.5],
        [10, 5.0],
        [12, 4.0],
        [14, 3.5],
    ],
    q36q48: [
        [6, 8.0],
        [8, 7.5],
        [10, 7.0],
        [12, 6.0],
        [14, 5.5],
    ],
    q48Exit: [
        [6, 11.0],
        [8, 10.5],
        [10, 10.0],
        [12, 9.0],
        [14, 8.5],
    ],
};
export const ALTERNATIVE_BOUNDARIES = {
    'barnes-jewish': {
        q24q36: [[6, 5.5], [8, 5.0], [10, 4.5], [12, 3.5], [14, 3.0]],
        q36q48: [[6, 7.5], [8, 7.0], [10, 6.5], [12, 5.5], [14, 5.0]],
        q48Exit: [[6, 10.5], [8, 10.0], [10, 9.5], [12, 8.5], [14, 8.0]],
    },
    'urban-craig': {
        q24q36: [[6, 5.0], [8, 4.5], [10, 4.0], [12, 3.0], [14, 2.5]],
        q36q48: [[6, 7.0], [8, 6.5], [10, 6.0], [12, 5.0], [14, 4.5]],
        q48Exit: [[6, 10.0], [8, 9.5], [10, 9.0], [12, 8.0], [14, 7.5]],
    },
    rochester: {
        q24q36: [[6, 6.5], [8, 6.0], [10, 5.5], [12, 4.5], [14, 4.0]],
        q36q48: [[6, 8.5], [8, 8.0], [10, 7.5], [12, 6.5], [14, 6.0]],
        q48Exit: [[6, 11.5], [8, 11.0], [10, 10.5], [12, 9.5], [14, 9.0]],
    },
};
//# sourceMappingURL=nomogramBoundaries.js.map